module.exports = __webpack_public_path__ + "ly.svg?cd565debb96e242e746aa98813efc648";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/ly.svg
// module id = 869
// module chunks = 27